/**
 * User: n.gorte
 * Date: 29.06.2022
 * Time: 11:49
 */

import React, { Fragment, useEffect } from 'external/react';
import PropTypes from 'external/prop-types';
import { boIcon } from '../../utils/icons';

const AutoCompleteListSectionHeader = ({ item, label, noResultsText, errorText }) => (
    <Fragment>
        <li className="leaflet-searchbox-autocomplete-item leaflet-searchbox-autocomplete-label">{label}</li>

        {!item.error && item.items.length === 0 &&
            <li className="leaflet-searchbox-autocomplete-item">{noResultsText}</li>
        }

        {item.error &&
            <li className="leaflet-searchbox-autocomplete-item">{errorText}</li>
        }
    </Fragment>
);

export const SearchBoxAutocomplete = ({
    suggestions,
    fliwasObjects,
    onSuggestionClick,
    onFliwasObjectClick,
    activeUuids,
    onClose
}) => {

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.keyCode === 27) {
                onClose();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, []);

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.keyCode === 13) {
                onSuggestionClick(suggestions.items[0]);
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [ suggestions ]);

    return (
        <ul className="leaflet-searchbox-autocomplete">
            <AutoCompleteListSectionHeader
                item={suggestions}
                label="Orte"
                errorText="Fehler bei der Anfrage"
                noResultsText="Keine Ergebnisse"
            />

            {!suggestions.error && suggestions.items.length > 0 && suggestions.items.map(item => {
                return (
                    <li
                        key={item.suggestion}
                        className="leaflet-searchbox-autocomplete-item"
                        onClick={() => onSuggestionClick(item)}
                    >
                        {item.suggestion}
                    </li>
                );
            })
            }

            <AutoCompleteListSectionHeader
                item={suggestions}
                label="FLIWAS-Objekte"
                errorText="Fehler bei der Anfrage"
                noResultsText="Keine Ergebnisse"
            />

            {activeUuids && Object.keys(activeUuids).length === 0 && (
                <li className="leaflet-searchbox-autocomplete-item leaflet-searchbox-autocomplete-fliwas-item">
                    <span>Keine FLIWAS-Objekt Layer aktiv</span>
                </li>
            )
            }

            {!fliwasObjects.error && fliwasObjects.items.length > 0 && fliwasObjects.items.map(item => {
                const fliwasObjectIcon = boIcon(item.properties.type, item.properties.typeKey || item.properties.gaugingStationTypeKey);
                const suffix = item.properties.type === 'GaugingStation' ? ` (${item.properties.waters})` : '';
                return (
                    <li
                        key={item.properties.id}
                        className="leaflet-searchbox-autocomplete-item leaflet-searchbox-autocomplete-fliwas-item"
                        onClick={() => onFliwasObjectClick(item)}
                    >
                        <img src={fliwasObjectIcon.options.iconUrl}/>
                        <span>{item.properties.title}{suffix}</span>
                    </li>
                );
            })}
        </ul>
    );
};

SearchBoxAutocomplete.propTypes = {
    suggestions: PropTypes.object.isRequired,
    fliwasObjects: PropTypes.object.isRequired,
    onSuggestionClick: PropTypes.func.isRequired,
    onFliwasObjectClick: PropTypes.func.isRequired,
    activeUuids: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

AutoCompleteListSectionHeader.propTypes = {
    item: PropTypes.object,
    label: PropTypes.string,
    noResultsText: PropTypes.string,
    errorText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/plugins/SearchPlugin/SearchBoxAutocomplete.jsx